import { RootState } from 'store/types';

export const getAnimations = (state: RootState) => state.adminAnimations.animations;

export const getCurrentAnimationId = (state : RootState) => state.adminAnimations.animations.currentAnimation.idAnimation;

export const getQuiz = (state: RootState) => state.adminAnimations.animations.quiz
